module.exports = __webpack_public_path__ + "img/1.a3a2c00c.jpg";